import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const DetailedAssessmentResultsApi = createApi({
  reducerPath: "getDetailedAssessmentResultsApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getDetailedAssessmentResultsApi: builder.query({
      query: ({ userId, scheduleId, attemptType, ongoingId }: any) => {
        return {
          url: "/graphql",
          body: gql`
           query GetDetailedAssessmentResults {
           getDetailedAssessmentResults(
           request: {
               userId: ["${userId}"], 
                scheduleId: "${scheduleId}", 
                attemptType: ${attemptType},
                ongoingId: "${ongoingId}",
                 pageNumber: 1
            pageSize: 50
              }
             ) {
             data {
            userDetails
            attempts {
                attemptNo
                attemptType
                ongoingId
                scheduleId
                scheduleTitle
                questionPaperId
                versionNumber
                setId
                overallSummary
                videoProctoringEnabled
                browserProctoringEnabled
                voilationAction
                obtainedMarks
                maxMarks
                percentage
                passStatus
                timeSpent
                startedAt
                userCompletedAt
                qpDuration
                adminExtendedduration
                scheduleType
                assessmentPattern
                showResults
                autoComplete
                maxAllowedAttempts
                timerEnabled
                timerSchema
                markingSchema
                passPercentage
                locked
                lockedType
                lockedAt
                skillAnalysis
                attemptCounts
                difficultyLevelAnalysis
                tags
                maxVoilationAllowed {
                    browserViolationCount
                    videoViolationCount
                }
                section {
                    sectionId
                    sectionTitle
                    orderInQp
                    maxMarks
                    obtainedMarks
                    sectionPercentage
                    timeSpent
                    duration
                    userStartedAt
                    userCompletedAt
                    totalQuestionCount
                    totalAttemptedQuestions
                    totalFlaggedQuestions
                    timerEnabled
                    locked
                    skills
                    tags
                    skillAnalysis
                    attemptCounts
                    difficultyLevelAnalysis
                     question {
                        rubricId
                        questionId
                        orderInSection
                        solutions
                        type
                        subType
                        versionnumber
                        difficulty
                        skills
                        maxMarks
                        obtainedMarks
                        timeSpent
                        userStartedAt
                        userCompletedAt
                        solutions
                        userSolutions
                        userFibSolutions
                        options
                        fibData
                        timerEnabled
                        locked
                        tags
                        problemStatement
                        accessibility
                        allowedCodingLanguages
                        hint
                        explanation
                        latestCodeId
                        language
                        candidateCode {
                            code
                            language
                            compiled
                            obtainedMarks
                            totalMarks
                            savedCodeId
                        }
                        status
                        title
                        submitCount
                        runCount
                        caseSensitive
                        submissionType
                    }
                    }
                     }
                     }
                   }
                 }
        `
        };
      },
      extraOptions: { service: "Assessment" }
    }),
    getSampleTestCasesInReport: builder.query({
      query: ({
        saveCodeId,
        pageNumber,
        pageSize
        //  sortKey,
        // sortOrder,
      }: {
        saveCodeId: string;
        pageNumber: number;
        pageSize: number;
        //  sortKey:any,
        // sortOrder:any,
      }) => ({
        url: `/ongoing/getTestcaseReport/${saveCodeId}?pageSize=${pageSize}&pageNumber=${pageNumber}`,
        // ?pageSize=10&sortBy=startDate
        method: "GET"
      }),
      extraOptions: { service: "Assessment" }
    }),
    getAttemptListApi: builder.query({
      query: ({
        scheduleId,
        userId
      }: {
        scheduleId: string;
        userId: string;
      }) => ({
        url: `/assessment/ongoing/library/all/attempts/${scheduleId}/${userId}`,
        method: "GET"
      }),
      extraOptions: { service: "Assessment" }
    })
  })
});

export const {
  useGetDetailedAssessmentResultsApiQuery,
  useLazyGetDetailedAssessmentResultsApiQuery,
  useGetSampleTestCasesInReportQuery,
  useGetAttemptListApiQuery
  // useLazyGetSampleTestCasesInReportQuery
} = DetailedAssessmentResultsApi;
